import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, MapPin, Phone, Clock } from "lucide-react";
import { BRAND, NAV_LINKS, SERVICES } from "@/lib/brand";

export const Footer = ({ onQuoteClick }) => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B1A33] text-white pt-24 pb-10"
    >
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="lg:col-span-5">
            <div className="inline-block bg-white rounded-2xl p-3">
              <img src="/logo.webp" alt="Bloc & Brush" className="h-10 w-auto object-contain" />
            </div>
            <p className="mt-6 text-white/65 max-w-md leading-relaxed text-[15px]">
              Dubai's turnkey partner for premium interior fit-out, MEP,
              facility maintenance, holiday home furnishing and professional
              cleaning services.
            </p>
            <button
              onClick={onQuoteClick}
              data-testid="footer-quote-btn"
              className="mt-8 inline-flex items-center gap-2 bg-white text-[#13294B] rounded-full px-6 py-3 text-sm font-medium hover:bg-white/90 transition"
            >
              Request a Quote <ArrowUpRight size={16} />
            </button>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.18em] text-white/45 font-medium">
              Quick Links
            </h4>
            <ul className="mt-6 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-[15px] text-white/75 hover:text-white transition"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.18em] text-white/45 font-medium">
              Services
            </h4>
            <ul className="mt-6 space-y-3">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <span className="text-[15px] text-white/75">{s.title}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.18em] text-white/45 font-medium">
              Contact
            </h4>
            <ul className="mt-6 space-y-4 text-[15px] text-white/75">
              <li className="flex gap-3">
                <MapPin size={16} className="mt-1 text-white/40 shrink-0" />
                <span>{BRAND.address}</span>
              </li>
              <li className="flex gap-3">
                <Phone size={16} className="mt-1 text-white/40 shrink-0" />
                <a href={BRAND.phoneHref} className="hover:text-white">
                  {BRAND.phone}
                </a>
              </li>
              <li className="flex gap-3">
                <Mail size={16} className="mt-1 text-white/40 shrink-0" />
                <a href={BRAND.emailHref} className="hover:text-white">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex gap-3">
                <Clock size={16} className="mt-1 text-white/40 shrink-0" />
                <span>{BRAND.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-white/50">
          <p>
            © {new Date().getFullYear()} Bloc & Brush Technical Services LLC. All
            rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="hover:text-white">
              Privacy
            </Link>
            <Link to="/" className="hover:text-white">
              Terms
            </Link>
            <span>Dubai · United Arab Emirates</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
